var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrapIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3,
    cy: 8.8,
    r: 3.6,
    stroke: "#A0F7E6",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4,
    cy: 23.2,
    r: 3.6,
    stroke: "#0BC196",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#68F4C9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14 8.8H9.5C5 8.8 5 16 9.5 16h13.6c4.5 0 4.5 7.2 0 7.2h-1.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0BC196",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m20.4 26-3.1-2.4a.5.5 0 0 1 0-.8l3-2.3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrapIn);
export default __webpack_public_path__ + "static/media/Wrap In.9309455ff8426c7d7e88db0db1ce1172.svg";
export { ForwardRef as ReactComponent };